import { memo } from 'react';
import { useRouter } from 'next/router';
import SortingBtn from './sortingBtn/SortingBtn';
import styles from './SortingMenuDesktop.module.scss';
import Divider from '@/components/UI/divider/Divider';
import Box from '@/components/UI/box/Box';
interface SortingMenuDesktopProps {
  handleSort: (index: number) => void;
}
const SortingMenuDesktop = ({
  handleSort
}: SortingMenuDesktopProps) => {
  const router = useRouter();
  const isSelected = (index: number) => Number(router.query?.sortBy) === index;
  return <Box className={styles['sorting-menu-container']} data-sentry-element="Box" data-sentry-component="SortingMenuDesktop" data-sentry-source-file="SortingMenuDesktop.tsx">
      <SortingBtn text="محبوب‌ترین" handleSort={() => handleSort(5)} selected={isSelected(5) || !router.query?.sortBy} data-sentry-element="SortingBtn" data-sentry-source-file="SortingMenuDesktop.tsx" />
      <Divider orientation="vertical" variant="middle" data-sentry-element="Divider" data-sentry-source-file="SortingMenuDesktop.tsx" />
      <SortingBtn text="ارزان‌ترین" handleSort={() => handleSort(3)} selected={isSelected(3)} data-sentry-element="SortingBtn" data-sentry-source-file="SortingMenuDesktop.tsx" />
      <Divider orientation="vertical" variant="middle" data-sentry-element="Divider" data-sentry-source-file="SortingMenuDesktop.tsx" />
      <SortingBtn text="گران‌ترین" handleSort={() => handleSort(2)} selected={isSelected(2)} data-sentry-element="SortingBtn" data-sentry-source-file="SortingMenuDesktop.tsx" />
    </Box>;
};
export default memo(SortingMenuDesktop);